import { useMemo } from "react";
import { getTitleOwners } from "../../../../../../ownership/helpers/getTitleOwners";
import { Title } from "react-migration/domains/ownership";
import { UltimateOwnershipInformation } from "../../UltimateOwnershipInformation";
import { TitleOwners } from "../../TitleOwners";
import { PropertyInformation } from "../../PropertyInformation";
import { useTitleInformation } from "../../../../../../ownership/helpers/useTitleInformation";

type Props = {
  titlesByLocation: Title[];
};

export const SingleTitleOwnershipInformation = ({ titlesByLocation }: Props) => {
  const { mainTitle, propertyId, parcelId } = useTitleInformation(titlesByLocation);
  const titleOwners = useMemo(() => getTitleOwners(mainTitle), [mainTitle]);

  return (
    <div data-testid="single-title-ownership-information">
      <UltimateOwnershipInformation owner={titleOwners[0]} />
      <TitleOwners titleOwners={titleOwners} />
      <PropertyInformation propertyId={propertyId} parcelId={parcelId} />
    </div>
  );
};
